"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6730],{

/***/ 36487:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export displayIcon */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97997);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11720);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react_toastify__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40782);
/* harmony import */ var _react_icons_all_files_fa_FaExclamationCircle__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55467);
/* harmony import */ var _react_icons_all_files_fa_FaBug__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45438);
/* harmony import */ var _react_icons_all_files_fa_FaExclamationTriangle__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3492);
/* harmony import */ var _react_icons_all_files_fa_FaCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35229);
/* harmony import */ var _react_icons_all_files_fa_FaInfo__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59365);









var displayIcon = function(type) {
    switch(type){
        case "success":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_react_icons_all_files_fa_FaCheck__WEBPACK_IMPORTED_MODULE_3__/* .FaCheck */ .l, {});
        case "info":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_react_icons_all_files_fa_FaInfo__WEBPACK_IMPORTED_MODULE_4__/* .FaInfo */ .L, {});
        case "error":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_react_icons_all_files_fa_FaExclamationCircle__WEBPACK_IMPORTED_MODULE_5__/* .FaExclamationCircle */ .a, {});
        case "warning":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_react_icons_all_files_fa_FaExclamationTriangle__WEBPACK_IMPORTED_MODULE_6__/* .FaExclamationTriangle */ .g, {});
        default:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_react_icons_all_files_fa_FaBug__WEBPACK_IMPORTED_MODULE_7__/* .FaBug */ .i, {});
    }
};
var ToastMessage = function(param) {
    var type = param.type, message = param.message;
    return react_toastify__WEBPACK_IMPORTED_MODULE_2__/* .toast */ .Am[type](/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
        style: {
            display: "flex"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                style: {
                    fontSize: 15,
                    paddingTop: 8,
                    flexShrink: 0,
                    textAlign: "center",
                    width: "30px",
                    color: "white"
                },
                children: displayIcon(type)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                style: {
                    flexGrow: 1,
                    fontSize: 15,
                    padding: "8px 12px",
                    color: "#333"
                },
                children: message
            })
        ]
    }));
};
ToastMessage.propTypes = {
    message: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string.isRequired),
    type: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string.isRequired)
};
ToastMessage.dismiss = react_toastify__WEBPACK_IMPORTED_MODULE_2__/* .toast.dismiss */ .Am.dismiss;
/* harmony default export */ __webpack_exports__["Z"] = (ToastMessage);


/***/ }),

/***/ 96994:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$D": function() { return /* binding */ GetMessage; },
/* harmony export */   "Bz": function() { return /* binding */ getActiveProductsWithPrices; },
/* harmony export */   "Dm": function() { return /* binding */ RWRFeatured; },
/* harmony export */   "JR": function() { return /* binding */ updatePersonalDetails; },
/* harmony export */   "P6": function() { return /* binding */ RWRDashboardNews; },
/* harmony export */   "PP": function() { return /* binding */ createReply; },
/* harmony export */   "Pi": function() { return /* binding */ myCourses; },
/* harmony export */   "Pm": function() { return /* binding */ GetReplyAuthor; },
/* harmony export */   "VH": function() { return /* binding */ updateRWRFeatured; },
/* harmony export */   "Vs": function() { return /* binding */ DeleteRepliesByMessage; },
/* harmony export */   "c7": function() { return /* binding */ updateUserRole; },
/* harmony export */   "nB": function() { return /* binding */ updateUserMyCourses; },
/* harmony export */   "ni": function() { return /* binding */ GetReplies; },
/* harmony export */   "o6": function() { return /* binding */ updateMessage; },
/* harmony export */   "pD": function() { return /* binding */ DeleteMessage; },
/* harmony export */   "pY": function() { return /* binding */ AllMessages; },
/* harmony export */   "tn": function() { return /* binding */ createMessage; },
/* harmony export */   "vI": function() { return /* binding */ MyMessages; },
/* harmony export */   "wG": function() { return /* binding */ myCompletedCourses; }
/* harmony export */ });
/* unused harmony exports supabase, MyUserDetails, updateUserName, DeleteReply */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70655);
/* harmony import */ var _supabase_supabase_auth_helpers_nextjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43528);
/* harmony import */ var _supabase_supabase_auth_helpers_nextjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_supabase_supabase_auth_helpers_nextjs__WEBPACK_IMPORTED_MODULE_0__);



var supabase = _supabase_supabase_auth_helpers_nextjs__WEBPACK_IMPORTED_MODULE_0__.supabaseClient;
var getActiveProductsWithPrices = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var ref, data, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        supabase.from("products").select("*, prices(*)").eq("active", true).eq("prices.type", "recurring").eq("prices.active", true).order("metadata->index").order("unit_amount", {
                            foreignTable: "prices"
                        })
                    ];
                case 1:
                    ref = _state.sent(), data = ref.data, error = ref.error;
                    if (error) {
                        // console.log(error.message);
                        throw error;
                    }
                    return [
                        2,
                        data || []
                    ];
            }
        });
    });
    return function getActiveProductsWithPrices() {
        return _ref.apply(this, arguments);
    };
}();
var MyUserDetails = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(myID) {
        var ref, data, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        supabase.from("users").select("id, first_name").eq("id", myID)
                    ];
                case 1:
                    ref = _state.sent(), data = ref.data, error = ref.error;
                    if (error) {
                        console.log(error.message);
                        throw error;
                    }
                    return [
                        2,
                        data || []
                    ];
            }
        });
    });
    return function MyUserDetails(myID) {
        return _ref.apply(this, arguments);
    };
}();
var updateUserName = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(user, full_name) {
        var ref, data, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        supabase.from("users").update({
                            full_name: full_name,
                            updated_at: new Date()
                        }).eq("id", user.id)
                    ];
                case 1:
                    ref = _state.sent(), data = ref.data, error = ref.error;
                    if (error) {
                        // console.log(error);
                        throw error;
                    }
                    return [
                        2,
                        data || []
                    ];
            }
        });
    });
    return function updateUserName(user, full_name) {
        return _ref.apply(this, arguments);
    };
}();
var updatePersonalDetails = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(user, userDB) {
        var ref, data, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        supabase.from("users").update({
                            full_name: userDB === null || userDB === void 0 ? void 0 : userDB.full_name,
                            first_name: userDB === null || userDB === void 0 ? void 0 : userDB.first_name,
                            last_name: userDB === null || userDB === void 0 ? void 0 : userDB.last_name,
                            billing_address: userDB === null || userDB === void 0 ? void 0 : userDB.billing_address,
                            updated_at: new Date()
                        }).eq("id", user.id)
                    ];
                case 1:
                    ref = _state.sent(), data = ref.data, error = ref.error;
                    if (error) {
                        // console.log(error.message);
                        throw error;
                    }
                    return [
                        2,
                        data || []
                    ];
            }
        });
    });
    return function updatePersonalDetails(user, userDB) {
        return _ref.apply(this, arguments);
    };
}();
var updateUserRole = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(userDB) {
        var ref, data, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        supabase.from("users").update({
                            role: userDB === null || userDB === void 0 ? void 0 : userDB.role,
                            updated_at: new Date()
                        }).eq("id", userDB.id)
                    ];
                case 1:
                    ref = _state.sent(), data = ref.data, error = ref.error;
                    if (error) {
                        // console.log(error.message);
                        throw error;
                    }
                    return [
                        2,
                        data || []
                    ];
            }
        });
    });
    return function updateUserRole(userDB) {
        return _ref.apply(this, arguments);
    };
}();
var myCourses = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(myID) {
        var ref, data, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        supabase.from("users").select("my_courses").eq("id", myID)
                    ];
                case 1:
                    ref = _state.sent(), data = ref.data, error = ref.error;
                    if (error) {
                        console.log(error.message);
                        throw error;
                    }
                    return [
                        2,
                        data || []
                    ];
            }
        });
    });
    return function myCourses(myID) {
        return _ref.apply(this, arguments);
    };
}();
var myCompletedCourses = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(myID) {
        var ref, data, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        supabase.from("completed_courses").select("*").eq("user_id", myID)
                    ];
                case 1:
                    ref = _state.sent(), data = ref.data, error = ref.error;
                    if (error) {
                        console.log(error.message);
                        throw error;
                    }
                    return [
                        2,
                        data || []
                    ];
            }
        });
    });
    return function myCompletedCourses(myID) {
        return _ref.apply(this, arguments);
    };
}();
var updateUserMyCourses = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(myID, myCourses) {
        var ref, data, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    console.log({
                        myID: myID,
                        myCourses: myCourses
                    });
                    return [
                        4,
                        supabase.from("users").update({
                            my_courses: myCourses,
                            updated_at: new Date()
                        }).eq("id", myID)
                    ];
                case 1:
                    ref = _state.sent(), data = ref.data, error = ref.error;
                    if (error) {
                        // console.log(error.message);
                        throw error;
                    }
                    return [
                        2,
                        data || []
                    ];
            }
        });
    });
    return function updateUserMyCourses(myID, myCourses) {
        return _ref.apply(this, arguments);
    };
}();
var createMessage = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(myID, myMessage) {
        var ref, data, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        supabase.from("messages").insert({
                            user_id: myID,
                            title: myMessage.title,
                            content: myMessage.content,
                            type: myMessage.type,
                            publish: myMessage.publish || true,
                            publish_at: myMessage.publish_at || new Date(),
                            created_at: new Date(),
                            updated_at: new Date()
                        })
                    ];
                case 1:
                    ref = _state.sent(), data = ref.data, error = ref.error;
                    if (error) {
                        // console.log(error.message);
                        throw error;
                    }
                    return [
                        2,
                        data || []
                    ];
            }
        });
    });
    return function createMessage(myID, myMessage) {
        return _ref.apply(this, arguments);
    };
}();
var updateMessage = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(id, updatedMessage) {
        var ref, data, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        supabase.from("messages").update({
                            title: updatedMessage.title,
                            content: updatedMessage.content,
                            type: updatedMessage.type,
                            publish: updatedMessage.publish || true,
                            publish_at: updatedMessage.publish_at || new Date(),
                            updated_at: new Date()
                        }).eq("id", id)
                    ];
                case 1:
                    ref = _state.sent(), data = ref.data, error = ref.error;
                    if (error) {
                        console.log(error.message);
                        throw error;
                    }
                    return [
                        2,
                        data || []
                    ];
            }
        });
    });
    return function updateMessage(id, updatedMessage) {
        return _ref.apply(this, arguments);
    };
}();
var DeleteMessage = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(id) {
        var ref, data, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        supabase.from("messages").delete().match({
                            id: id
                        })
                    ];
                case 1:
                    ref = _state.sent(), data = ref.data, error = ref.error;
                    if (error) {
                        console.log(error.message);
                        throw error;
                    }
                    return [
                        2,
                        data || []
                    ];
            }
        });
    });
    return function DeleteMessage(id) {
        return _ref.apply(this, arguments);
    };
}();
var GetMessage = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(id) {
        var ref, data, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        supabase.from("messages").select("*").eq("id", id).limit(1).single()
                    ];
                case 1:
                    ref = _state.sent(), data = ref.data, error = ref.error;
                    if (error) {
                        console.log(error.message);
                        throw error;
                    }
                    return [
                        2,
                        data || []
                    ];
            }
        });
    });
    return function GetMessage(id) {
        return _ref.apply(this, arguments);
    };
}();
var MyMessages = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(myID, type) {
        var ref, data, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        supabase.from("messages").select("*, author: users(id, full_name, first_name, last_name, avatar_url, email, role)").eq("user_id", myID).eq("type", type).order("publish_at", {
                            ascending: false
                        })
                    ];
                case 1:
                    ref = _state.sent(), data = ref.data, error = ref.error;
                    if (error) {
                        console.log(error.message);
                        throw error;
                    }
                    return [
                        2,
                        data || []
                    ];
            }
        });
    });
    return function MyMessages(myID, type) {
        return _ref.apply(this, arguments);
    };
}();
var AllMessages = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(type) {
        var ref, data, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        supabase.from("messages").select("*, author: users(id, full_name, first_name, last_name, avatar_url, email, role)").eq("type", type).order("publish_at", {
                            ascending: false
                        })
                    ];
                case 1:
                    ref = _state.sent(), data = ref.data, error = ref.error;
                    if (error) {
                        console.log(error.message);
                        throw error;
                    }
                    return [
                        2,
                        data || []
                    ];
            }
        });
    });
    return function AllMessages(type) {
        return _ref.apply(this, arguments);
    };
}();
var createReply = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(myID, myReply) {
        var ref, data, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        supabase.from("replies").insert({
                            user_id: myID,
                            message_id: myReply.message_id,
                            content: myReply.content,
                            publish: myReply.publish || true,
                            publish_at: myReply.publish_at || new Date(),
                            created_at: new Date(),
                            updated_at: new Date()
                        })
                    ];
                case 1:
                    ref = _state.sent(), data = ref.data, error = ref.error;
                    if (error) {
                        console.log(error.message);
                        throw error;
                    }
                    return [
                        2,
                        data || []
                    ];
            }
        });
    });
    return function createReply(myID, myReply) {
        return _ref.apply(this, arguments);
    };
}();
var GetReplies = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(message_id) {
        var ref, data, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        supabase.from("replies").select("*, author: users(id, full_name, first_name, last_name, avatar_url, email, role)").eq("message_id", message_id).order("publish_at", {
                            ascending: false
                        })
                    ];
                case 1:
                    ref = _state.sent(), data = ref.data, error = ref.error;
                    if (error) {
                        console.log(error.message);
                        throw error;
                    }
                    return [
                        2,
                        data || []
                    ];
            }
        });
    });
    return function GetReplies(message_id) {
        return _ref.apply(this, arguments);
    };
}();
var DeleteRepliesByMessage = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(id) {
        var ref, data, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        supabase.from("replies").delete().eq("message_id", id)
                    ];
                case 1:
                    ref = _state.sent(), data = ref.data, error = ref.error;
                    if (error) {
                        console.log(error.message);
                        throw error;
                    }
                    return [
                        2,
                        data || []
                    ];
            }
        });
    });
    return function DeleteRepliesByMessage(id) {
        return _ref.apply(this, arguments);
    };
}();
var DeleteReply = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(id) {
        var ref, data, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        supabase.from("replies").delete().match({
                            id: id
                        })
                    ];
                case 1:
                    ref = _state.sent(), data = ref.data, error = ref.error;
                    if (error) {
                        console.log(error.message);
                        throw error;
                    }
                    return [
                        2,
                        data || []
                    ];
            }
        });
    });
    return function DeleteReply(id) {
        return _ref.apply(this, arguments);
    };
}();
var GetReplyAuthor = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(user_id) {
        var ref, data, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        supabase.from("users").select("id, full_name, first_name, last_name, avatar_url, email, role").eq("id", user_id).limit(1).single()
                    ];
                case 1:
                    ref = _state.sent(), data = ref.data, error = ref.error;
                    if (error) {
                        console.log(error.message);
                        throw error;
                    }
                    return [
                        2,
                        data || []
                    ];
            }
        });
    });
    return function GetReplyAuthor(user_id) {
        return _ref.apply(this, arguments);
    };
}();
var RWRDashboardNews = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var ref, data, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        supabase.from("messages").select("*, author: users(id, full_name, first_name, last_name, avatar_url, email, role)").limit(5).eq("type", "news").order("updated_at", {
                            ascending: false
                        })
                    ];
                case 1:
                    ref = _state.sent(), data = ref.data, error = ref.error;
                    if (error) {
                        console.log(error.message);
                        throw error;
                    }
                    return [
                        2,
                        data || []
                    ];
            }
        });
    });
    return function RWRDashboardNews() {
        return _ref.apply(this, arguments);
    };
}();
var RWRFeatured = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(id) {
        var ref, data, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        supabase.from("featured").select("*").eq("id", id).limit(1).single()
                    ];
                case 1:
                    ref = _state.sent(), data = ref.data, error = ref.error;
                    if (error) {
                        console.log(error.message);
                        throw error;
                    }
                    return [
                        2,
                        data || []
                    ];
            }
        });
    });
    return function RWRFeatured(id) {
        return _ref.apply(this, arguments);
    };
}();
var updateRWRFeatured = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(id, text, featured_content) {
        var ref, data, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        supabase.from("featured").update({
                            text: text,
                            featured_content: featured_content,
                            updated_at: new Date()
                        }).eq("id", id)
                    ];
                case 1:
                    ref = _state.sent(), data = ref.data, error = ref.error;
                    if (error) {
                        // console.log(error.message);
                        throw error;
                    }
                    return [
                        2,
                        data || []
                    ];
            }
        });
    });
    return function updateRWRFeatured(id, text, featured_content) {
        return _ref.apply(this, arguments);
    };
}();


/***/ })

}]);